import {
  NameAndArea,
  PointOfInterestFindingAndName,
  PointOfInterestsFindingsByDeckAndPaintBlock,
} from '@/__generated__/graphql';

export type KeyValueMap = { [key: string]: string | number };

export const convertDefects = (
  defectsData: NameAndArea[],
  selectedCoatingCondition: string[] = []
) => {
  return defectsData.map((item) => {
    const result: KeyValueMap = { name: item.name };

    item.totalArea?.forEach((defect) => {
      if (defect?.type && selectedCoatingCondition.includes(defect.type.toLowerCase()))
        result[defect.type.toLowerCase()] = defect?.value ?? 0;
    });

    return result;
  });
};

export const mapPOIType = (type: string) =>
  type
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const convertFindings = (findingsData: PointOfInterestFindingAndName[]) => {
  return findingsData.map((item) => {
    const result: KeyValueMap = { name: item.name };

    item.pointOfInterestFindings.forEach((finding) => {
      result[mapPOIType(finding.type)] = finding.count; // Capitalize first letter of each word
    });

    return result;
  });
};

export const mapFindingsData = (
  findings: PointOfInterestsFindingsByDeckAndPaintBlock | undefined
) => ({
  findingsCountByDeck: convertFindings(findings?.findingsByDeck || []),
  findingsCountByPaintBlock: convertFindings(findings?.findingsByPaintBlock || []),
});
